import Tagify from '@yaireo/tagify';

window.Tagify = Tagify

export function canMakeTagifyReadonly() {
  return !!getPreviousStepsEl()
}

function getPreviousStepsEl() {
  return document.getElementById('previous_steps')
}

export function makeTagifyReadonly(inputElement) {
  if (!canMakeTagifyReadonly()) {
    return
  }

  inputElement.classList.add('tagify--readonly')

  const previousStepsEl = getPreviousStepsEl()
  const settings = buildReadonlySettings(previousStepsEl.dataset.previous_steps,
                                        previousStepsEl.dataset.variable,
                                        previousStepsEl.dataset.update_reference_fields)

  let tagify = new Tagify(inputElement, settings);

  tagify.setReadonly(true)

  return tagify
}

export function buildReadonlySettings(previous_steps, variable, update_reference_fields) {
  let whitelist = [];

  if (previous_steps.length > 0) {
    JSON.parse(previous_steps).forEach(step => whitelist.push(step));
  }

  if (update_reference_fields && update_reference_fields.length > 0) {
    JSON.parse(update_reference_fields).forEach(step => whitelist.push(step));
  }

  if (variable) {
    whitelist.push(JSON.parse(variable));
  }

  const transformUpdateReference = function(tag) {
    const whitelistedTag = whitelist.find(wt => wt.value === tag.value);

    if (whitelistedTag) {
      Object.assign(tag, whitelistedTag, { freeText: '' });
    } else {
      customTag(tag);
    }
  };

  const transformTag = function(tag) {
    const uuid = extractUuidAndFreetext(tag.value)[0];
    const freeText = extractUuidAndFreetext(tag.value)[1];
    const whitelistedTag = whitelist.find(tag => tag.value === uuid);

    if (whitelistedTag) {
      Object.assign(tag, whitelistedTag, { freeText: freeText })
    } else {
      customTag(tag)
    }
  };

  const settings = {
    whitelist: whitelist,
    mixTagsInterpolator: ["{{", "}}"],
    maxTags: 20,
    mode: 'mix',
    pattern: /\{\{\s*/, // '{{'
    tagTextProp: 'value',
    enforceWhitelist: false,
    skipInvalid: true,
    editTags: false,
    pasteAsTags: false,
    duplicates: true,
    backspace: false,
    readonly: true,
    classNames: {
      tag: 'tagify__tag readonly',
      tags: 'tagify tagify--mix tagify--readonly'
    },
    transformTag: (update_reference_fields && update_reference_fields.length > 0)
      ? transformUpdateReference
      : transformTag,
    templates: {
      tag: readonlyTagTemplate
    }
  }

  return settings
}

function extractUuidAndFreetext(rawStr) {
  const str = rawStr ? rawStr.trim() : "";
  const dotIndex = str.indexOf('.') === -1 ? str.length : str.indexOf('.');
  const spaceIndex = str.indexOf(' ') === -1 ? str.length : str.indexOf(' ');
  const pipeIndex = str.indexOf('|') === -1 ? str.length : str.indexOf('|');
  if (dotIndex === -1 && spaceIndex === -1 && pipeIndex === -1) {
    return [str, '']
  }
  const splitIndex = Math.min(dotIndex, spaceIndex, pipeIndex);
  const uuid = str.slice(0, splitIndex);
  const freeText = str.slice(splitIndex);
  return [uuid, freeText]
}

function customTag(tag) {
  const tagValue = tag.value ? tag.value : "";
  const splitText = tagValue.split('|').map(v => v.trim());
  const name = splitText.shift();
  splitText.unshift('')
  const freeText = splitText.join(' | ');
  Object.assign(tag, { freeText: freeText, name: name, value: name, avatar: '' });
}

function readonlyTagTemplate(tagData) {
  const freeText = tagData.freeText || '';
  const showValue = freeText.length > 0 && !tagData.input_disabled;

  return `
    <tag title="${tagData.name}"
      id="tag-${tagData.value}-${new Date().getTime()}"
      contenteditable='false'
      spellcheck='false'
      tabIndex="-1"
      class="tagify__tag ${tagData.class ? tagData.class : ""} justify-start readonly"
      ${this.getAttributes(tagData)}>

      <div class="">
        ${tagData.avatar ? `<div class='mx-1'>${tagData.avatar}</div>` : ''}
        <div class="py-1"><span>${tagData.name}</span></div>
      </div>

      ${showValue ? `<div class="shrink">
        <div>
          <span
            class='inner-input tagify-inner-input min-w-8 font-mono readonly'
            tabIndex='-1'
            >${freeText.toHtmlEntities()}</span>
        </div>
      </div>` : ''}
    </tag>
  `
}
